export const getRuntimeEnv = () => {
  return (window as any).__ENV__ || {};
};
